import { Grid } from "@mui/material";
import CustomCell from "./CustomCell";
import i18n from "i18next";

const PreOrderInfo = () => {
  return (
    <Grid
      container
      sx={{
        py: 3,
        px: 10,
        mt: 2,
        borderRadius: "5px",
        border: "1px solid #E8EBFD",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Grid item>
        <CustomCell
          label={i18n.t("preOrder.labels.client")}
          value="Ahmed mohamed"
        />
      </Grid>
      <Grid item>
        <CustomCell
          label={i18n.t("preOrder.labels.orderDate")}
          value="15/03/2024"
        />
      </Grid>
      <Grid item>
        <CustomCell
          label={i18n.t("preOrder.labels.salesSite")}
          value="Ain sbaa"
        />
      </Grid>
      <Grid item>
        <CustomCell
          label={i18n.t("preOrder.labels.expeditionSite")}
          value="Ain sbaa"
        />
      </Grid>
      <Grid item>
        <CustomCell
          label={i18n.t("preOrder.labels.salesSite")}
          value="En cours"
        />
      </Grid>
    </Grid>
  );
};

export default PreOrderInfo;
